import React from 'react';
import ReportViewer from "./base/ReportViewer";

const JournalPaiements = () => {

    return (
        <div style={{ height: "100%" }}>
            <ReportViewer reportName={"JournalPaiementsReport"} />
        </div>
    );
}
export default JournalPaiements;